import { Div, Button, Input } from '@codesuma/baseline'
import style from './index.module.css'

// A name of the reader's own for an occasion that is not theirs. The panel the
// adopt dialog uses, with a field in it instead of a question.
//
// Emits 'save' with what was typed, or 'close'. An emptied field saves as empty,
// which the override store reads as the original name back again — so clearing
// it is how a rename is undone from here.
export const RenameDialog = (current: string, original: string) => {
    const base = Div()
    base.addClass(style.dialogBase)
    // Also what keeps a drag on it from pulling the sheet down (see pages/day).
    base.attr('role', 'dialog')

    const panel = Div()
    panel.addClass(style.dialogPanel)
    base.append(panel)

    const title = Div('نام تازه')
    title.addClass(style.dialogTitle)
    panel.append(title)

    // The name it came with, so emptying the field reads as a choice rather
    // than as losing something.
    const why = Div(`اگر خالی بماند، «${original}» برمی‌گردد.`)
    why.addClass(style.dialogWhy)
    panel.append(why)

    const field = Input(original, 'text')
    field.addClass(style.dialogField)
    field.attr('dir', 'auto')
    field.setValue(current)
    field.on('enter', () => base.emit('save', field.value()))
    panel.append(field)

    const actions = Div()
    actions.addClass(style.dialogActions)
    panel.append(actions)

    const save = Button('ذخیره')
    save.addClass(style.dialogPrimary)
    save.on('click', () => base.emit('save', field.value()))
    actions.append(save)

    const cancel = Button('بی‌خیال')
    cancel.addClass(style.dialogSecondary)
    cancel.on('click', () => base.emit('close'))
    actions.append(cancel)

    base.on('click', (e: MouseEvent) => {
        if (e.target === base.el) base.emit('close')
    })

    // After the panel has settled, so the keyboard does not open onto a moving
    // field — the same beat the wizard's steps take.
    setTimeout(() => field.focus(), 160)

    return base
}
